import { render, staticRenderFns } from "./videoCoursePage.vue?vue&type=template&id=afe3fe1e&scoped=true&"
import script from "./videoCoursePage.vue?vue&type=script&lang=js&"
export * from "./videoCoursePage.vue?vue&type=script&lang=js&"
import style0 from "./videoCoursePage.vue?vue&type=style&index=0&id=afe3fe1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe3fe1e",
  null
  
)

export default component.exports